import $ from 'jquery';
import Component from '../models/Component';

export default class Accordion extends Component {
    constructor(element, context) {
        super(element, context);


        const questions = this.element.find(".faq_question");        

        if (questions.length > 0) {
            const firstQuestion = $(questions[0]);
            const firstIcon = firstQuestion.find(".icon");
            const firstAnswer = firstQuestion.next(); 
          
            firstQuestion.addClass("active");
            firstIcon.addClass("active");
            if (firstAnswer && firstAnswer.style) {
                firstAnswer.style.maxHeight = firstAnswer.scrollHeight + "px";
            }
            if (firstAnswer.length > 0) {
                firstAnswer.css("max-height", firstAnswer[0].scrollHeight + "px");
            }
        }

        questions.each((index, questionJs) => {
            const question = $(questionJs);
            const icon = question.find(".icon-shape");

            question.on("click", () => {
                const activeQuestion = $(".faq_question.active");
                const activeIcon = $(".icon-shape.active");
                

                if (activeQuestion.length && !activeQuestion.is(question)) {
                    activeQuestion.removeClass("active");
                    activeIcon.removeClass("active");

                    activeQuestion.next().css("max-height", "0px");
                }

                question.toggleClass("active");
                icon.toggleClass("active");

                const answer = question.next();
                if (question.hasClass("active")) {
                    answer.css("max-height", answer[0].scrollHeight + "px");
                } else {
                    answer.css("max-height", "0px");
                }

            });
            
        });
            

        
    }
}
